import React, { useEffect, useState } from 'react';
import { isAdminAuthenticated, getAdminProfile, logoutAdmin } from '../services/adminApi';
import NotFoundPage from '../pages/NotFoundPage';

// A wrapper component for admin routes that shows 404 to non-authenticated users
// instead of redirecting to login page
export default function AdminProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        if (isAdminAuthenticated()) {
          // Verify token validity with backend
          const response = await getAdminProfile();
          if (response.success) {
            setAuthenticated(true);
          } else {
            // Token invalid or expired
            logoutAdmin();
            setAuthenticated(false);
          }
        } else {
          setAuthenticated(false);
        }
      } catch (error) {
        console.error('Authentication verification failed:', error);
        logoutAdmin();
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    verifyAuth();
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  if (!authenticated) {
    // Show 404 page instead of redirecting to login
    return <NotFoundPage />;
  }

  return children;
}
